import React from 'react';
import { ShieldCheck, ShieldAlert, RefreshCw } from 'lucide-react';

// Selo de confiabilidade da leitura.
// Uso:  <SeloConfiabilidade confidence={result.confidence} onRefazer={resetTeste} />
const SeloConfiabilidade = ({ confidence, onRefazer }) => {
  if (!confidence) return null;
  const { flag, score } = confidence;

  const cfg = {
    alta:  { cor: 'from-emerald-900/30 to-teal-900/30 border-emerald-500/25', txt: 'text-emerald-200', Icon: ShieldCheck,
             titulo: 'Leitura confiável', msg: 'Suas respostas foram consistentes e atentas. Esta leitura reflete bem o seu momento.' },
    media: { cor: 'from-amber-900/30 to-yellow-900/30 border-amber-500/25', txt: 'text-amber-200', Icon: ShieldCheck,
             titulo: 'Leitura razoável', msg: 'Há boa coerência nas respostas. Se quiser uma leitura ainda mais precisa, vale refazer com calma.' },
    baixa: { cor: 'from-rose-900/30 to-orange-900/30 border-rose-500/25', txt: 'text-rose-200', Icon: ShieldAlert,
             titulo: 'Leitura a refazer com calma', msg: 'Percebemos respostas rápidas ou pouco consistentes. Num momento de quietude, o seu coração responde com mais verdade.' },
  }[flag] || {};

  const { Icon } = cfg;
  return (
    <div className={`bg-gradient-to-br ${cfg.cor} backdrop-blur-sm rounded-2xl p-4 border flex items-center gap-4`} data-testid="selo-confiabilidade">
      {Icon && <Icon className={`w-7 h-7 ${cfg.txt} flex-shrink-0`} />}
      <div className="flex-grow">
        <div className="flex items-center gap-2">
          <p className={`font-semibold text-sm ${cfg.txt}`}>{cfg.titulo}</p>
          <span className="text-white/40 text-xs">· confiança {score}/100</span>
        </div>
        <p className="text-white/70 text-sm leading-relaxed mt-0.5">{cfg.msg}</p>
      </div>
      {flag === 'baixa' && onRefazer && (
        <button onClick={onRefazer} data-testid="selo-refazer"
          className="flex items-center gap-2 px-4 py-2 bg-white/10 hover:bg-white/20 text-white rounded-lg transition-all text-sm flex-shrink-0" style={{ border: 'none' }}>
          <RefreshCw className="w-4 h-4" /> Refazer com calma
        </button>
      )}
    </div>
  );
};

export default SeloConfiabilidade;
